(function () {
  "use strict";
  var doc = document;
  var docEl = doc.documentElement;
  var SELECTOR = ".xg-reveal";
  var STATE = "data-xg-reveal";
  var reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function threshold() {
    var raw = getComputedStyle(docEl)
      .getPropertyValue("--xg-reveal-threshold")
      .trim();
    var n = parseFloat(raw);
    return isFinite(n) && n >= 0 && n <= 1 ? n : 0.12;
  }
  function markIn(el) {
    el.setAttribute(STATE, "in");
  }
  if (reduced || typeof window.IntersectionObserver !== "function") {
    var all = doc.querySelectorAll(SELECTOR);
    for (var i = 0; i < all.length; i += 1) markIn(all[i]);
    docEl.setAttribute("data-xg-reveal-ready", "");
    window.XG = window.XG || {};
    window.XG.reveal = {
      scan: function (root) {
        var nodes = (root || doc).querySelectorAll(SELECTOR);
        for (var j = 0; j < nodes.length; j += 1) markIn(nodes[j]);
      },
      observer: null
    };
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        markIn(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { threshold: threshold() }
  );
  function observe(el) {
    if (el.getAttribute(STATE) === "in") return;
    observer.observe(el);
  }
  function scan(root) {
    var scope = root || doc;
    if (scope.nodeType === 1 && scope.matches && scope.matches(SELECTOR)) {
      observe(scope);
    }
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < nodes.length; i += 1) observe(nodes[i]);
  }
  scan(doc);
  var mutations = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j += 1) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  });
  mutations.observe(doc.body || docEl, { childList: true, subtree: true });
  docEl.setAttribute("data-xg-reveal-ready", "");
  window.XG = window.XG || {};
  window.XG.reveal = { scan: scan, observer: observer };
})();
